import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { serverLink } from "../../../resources/url";
import DataLoader from "../../common/dataLoader/dataLoader";
import DataTable from "../../common/data-table/data-table";
import { formatDateAndTime, currencyConverter } from "../../../resources/constants";

function KeffiStudentReport(props) {
    const [IsLoading, setIsLoading] = useState(true);
    const [studentList, setStudentList] = useState([]);

    const header = [
        "S/N",
        "Name",
        "Gender",
        "Nationality",
        "State_Of_Origin",
        "DATE_OF_BIRTH",
        "Programme",
        "Admission_Year",
    ];

    const paymentHeader = [
        "Transaction ID",
        "Payment Type",
        "Pay Code",
        "Amount",
        "Reference",
        "Session",
        "Date Paid",
    ];

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        setIsLoading(true);
        await axios
            .get(`${serverLink}staff/report/registration/student/keffi/report`)
            .then((result) => {
                if (result.data.length > 0) {
                    setStudentList(result.data);
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.log("NETWORK ERROR", err);
                setIsLoading(false);
            });
    };

    // ── Derived stats ──────────────────────────────────────────────────────────
    const totalStudents = studentList.length;

    const totalAmountPaid = studentList.reduce((grand, student) => {
        const studentTotal = (student.PAYMENTS || []).reduce((sum, pay) => {
            return sum + (parseFloat(pay.AMOUNT) || 0);
        }, 0);
        return grand + studentTotal;
    }, 0);

    const getStudentSubtotal = (payments) =>
        (payments || []).reduce((sum, pay) => sum + (parseFloat(pay.AMOUNT) || 0), 0);

    const fmt = (amount) =>
        currencyConverter ? currencyConverter(amount) : amount.toLocaleString("en-NG", { style: "currency", currency: "NGN" });

    const showPaymentsSubTable = (payments) => {
        if (!payments || payments.length === 0) {
            return (
                <tr>
                    <td
                        colSpan={paymentHeader.length + 1}
                        className="text-center text-muted"
                        style={{ fontStyle: "italic", padding: "10px" }}
                    >
                        No active payment records found.
                    </td>
                </tr>
            );
        }

        const subtotal = getStudentSubtotal(payments);

        return (
            <>
                {payments.map((pay, pIdx) => (
                    <tr key={pIdx}>
                        <td className="text-xs font-weight-bold">{pay.TRANSACTION_ID}</td>
                        <td className="text-xs font-weight-bold">{pay.PAYMENT_TYPE}</td>
                        <td className="text-xs font-weight-bold">{pay.PAYCODE}</td>
                        <td className="text-xs font-weight-bold">
                            {currencyConverter ? currencyConverter(pay.AMOUNT) : pay.AMOUNT}
                        </td>
                        <td className="text-xs font-weight-bold">{pay.REFERENCE}</td>
                        <td className="text-xs font-weight-bold">{pay.SESSION_CODE}</td>
                        <td className="text-xs font-weight-bold">{pay.DATE_PAID}</td>
                    </tr>
                ))}
                {/* Per-student subtotal row */}
                <tr style={{ background: "#d4edda", fontWeight: 700 }}>
                    <td colSpan={3} className="text-xs" style={{ fontWeight: 700 }}>
                        Sub-Total ({payments.length} payment{payments.length !== 1 ? "s" : ""})
                    </td>
                    <td className="text-xs" style={{ fontWeight: 700, color: "#155724" }}>
                        {fmt(subtotal)}
                    </td>
                    <td colSpan={3} />
                </tr>
            </>
        );
    };

    const showTable = () => {
        try {
            return studentList.map((item, index) => (
                <React.Fragment key={index}>
                    {/* Student info row */}
                    <tr>
                        <td className="text-xs font-weight-bold">{index + 1}</td>
                        <td className="text-xs font-weight-bold">{item.STUDENT_NAME}</td>
                        <td className="text-xs font-weight-bold">{item.GENDER}</td>
                        <td className="text-xs font-weight-bold">{item.NATIONALITY}</td>
                        <td className="text-xs font-weight-bold">{item.STATE_OF_ORIGIN}</td>
                        <td className="text-xs font-weight-bold">
                            {item.DOB && item.DOB !== ""
                                ? formatDateAndTime(item.DOB, "date")
                                : "N/A"}
                        </td>
                        <td className="text-xs font-weight-bold">{item.PROGRAMME}</td>
                        <td className="text-xs font-weight-bold">{item.ADMISSION_YEAR}</td>
                    </tr>

                    {/* Always-visible payment sub-table */}
                    <tr>
                        <td colSpan={header.length} style={{ padding: 0 }}>
                            <div
                                style={{
                                    background: "#f8f9fa",
                                    borderLeft: "4px solid #206bc4",
                                    padding: "10px 20px 14px",
                                }}
                            >
                                <h5
                                    style={{
                                        marginBottom: "8px",
                                        color: "#206bc4",
                                        fontSize: "12px",
                                        fontWeight: 600,
                                    }}
                                >
                                    Payment Records — {item.STUDENT_NAME}
                                </h5>
                                <div className="table-responsive">
                                    <table className="table table-sm table-bordered table-hover mb-0">
                                        <thead>
                                            <tr>
                                                {paymentHeader.map((h, i) => (
                                                    <th
                                                        key={i}
                                                        className="text-xs"
                                                        style={{
                                                            background: "#e9ecef",
                                                            fontWeight: 600,
                                                            fontSize: "11px",
                                                        }}
                                                    >
                                                        {h}
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {showPaymentsSubTable(item.PAYMENTS)}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </td>
                    </tr>
                </React.Fragment>
            ));
        } catch (e) {
            alert(e.message);
        }
    };

    return IsLoading ? (
        <div className="container-xl" style={{ height: "700px" }}>
            <div className="page-header d-print-none">
                <DataLoader />
            </div>
        </div>
    ) : (
        <>
            <div className="container-xl">
                <div className="page-header d-print-none">
                    <div className="row align-items-center">
                        <div className="col">
                            <div className="page-pretitle">Reports</div>
                            <h2 className="page-title">
                                Keffi Students Report
                            </h2>
                        </div>
                        <div className="col-auto ms-auto d-print-none">
                            <span className="badge bg-blue text-white" style={{ fontSize: "13px" }}>
                                Total: {studentList.length} Student(s)
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="page-body">
                <div className="container-xl">
                    <div className="row row-deck row-cards">
                        <div className="col-lg-12">
                            <div className="row row-cards">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <h3 className="card-title">
                                                Keffi Students — Student &amp; Payment Report
                                            </h3>
                                            <p className="text-muted" style={{ fontSize: "12px" }}>
                                                Each student's payment records are shown directly below their details row.
                                            </p>

                                            {/* ── Stats strip ── */}
                                            <div className="row g-2 mb-3">
                                                <div className="col-auto">
                                                    <div className="card card-sm" style={{ minWidth: "160px", border: "1px solid #206bc4" }}>
                                                        <div className="card-body py-2 px-3">
                                                            <div className="text-muted" style={{ fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.05em" }}>Total Students</div>
                                                            <div style={{ fontSize: "22px", fontWeight: 700, color: "#206bc4", lineHeight: 1.2 }}>{totalStudents}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-auto">
                                                    <div className="card card-sm" style={{ minWidth: "220px", border: "1px solid #2fb344" }}>
                                                        <div className="card-body py-2 px-3">
                                                            <div className="text-muted" style={{ fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.05em" }}>Total Amount Paid</div>
                                                            <div style={{ fontSize: "22px", fontWeight: 700, color: "#2fb344", lineHeight: 1.2 }}>{fmt(totalAmountPaid)}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-auto">
                                                    <div className="card card-sm" style={{ minWidth: "160px", border: "1px solid #f59f00" }}>
                                                        <div className="card-body py-2 px-3">
                                                            <div className="text-muted" style={{ fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.05em" }}>Students with Payments</div>
                                                            <div style={{ fontSize: "22px", fontWeight: 700, color: "#f59f00", lineHeight: 1.2 }}>
                                                                {studentList.filter(s => s.PAYMENTS && s.PAYMENTS.length > 0).length}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {studentList.length > 0 ? (
                                                <DataTable
                                                    header={header}
                                                    body={showTable()}
                                                    title="Keffi Students Report"
                                                />
                                            ) : (
                                                <div
                                                    className="alert alert-important alert-info alert-dismissible"
                                                    role="alert"
                                                >
                                                    <div className="d-flex">
                                                        <div>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                className="icon alert-icon"
                                                                width="24"
                                                                height="24"
                                                                viewBox="0 0 24 24"
                                                                strokeWidth="2"
                                                                stroke="currentColor"
                                                                fill="none"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            >
                                                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                                <circle cx="12" cy="12" r="9" />
                                                                <line x1="12" y1="8" x2="12.01" y2="8" />
                                                                <polyline points="11 12 12 12 12 16 13 16" />
                                                            </svg>
                                                        </div>
                                                        <div>No Keffi students found in the system.</div>
                                                    </div>
                                                    <a
                                                        className="btn-close btn-close-white"
                                                        data-bs-dismiss="alert"
                                                        aria-label="close"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        loginData: state.loginDetails,
    };
};

export default connect(mapStateToProps, null)(KeffiStudentReport);
